import { SwayyEmployeeRoles } from "../Employees/SwayyEmployeeRoles";

export type SwayyCouponAccessAction = "view" | "edit" | "create";

export interface SwayyCouponAccess {
  canView: boolean;
  canEdit: boolean;
  canCreate: boolean;
}

/**
 * Coupon access is explicit.
 * Create requires `create_coupons` only — `all` and `edit_coupons` never grant create.
 * `create_coupons` also allows editing existing coupons. `all` is view-only.
 */
export function canAccessSwayyCoupon(
  permissions: readonly string[] | undefined,
  action: SwayyCouponAccessAction,
): boolean {
  if (!permissions?.length) return false;
  const has = (role: SwayyEmployeeRoles) => permissions.includes(role);

  if (action === "create") {
    return has(SwayyEmployeeRoles.CREATE_COUPONS);
  }

  const canEdit =
    has(SwayyEmployeeRoles.CREATE_COUPONS) ||
    has(SwayyEmployeeRoles.EDIT_COUPONS);

  if (action === "edit") return canEdit;

  return (
    canEdit ||
    has(SwayyEmployeeRoles.VIEW_COUPONS) ||
    has(SwayyEmployeeRoles.ALL)
  );
}

export function getSwayyCouponAccess(
  permissionMap: Map<string, string> | undefined,
): SwayyCouponAccess {
  const permissions = permissionMap ? Array.from(permissionMap.keys()) : [];
  return {
    canView: canAccessSwayyCoupon(permissions, "view"),
    canEdit: canAccessSwayyCoupon(permissions, "edit"),
    canCreate: canAccessSwayyCoupon(permissions, "create"),
  };
}
